var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultWorkoutImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 71,
    rx: 7.5,
    fill: "#000632",
    fillOpacity: 0.25,
    stroke: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9388 39.6626L32.014 42.5098L34.4062 44.845L32.2419 48.376L30.9322 44.5602L28.7109 40.6874L28.9388 39.6626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1463 45.585L32.9258 49.0589L33.7796 53.7285L35.3172 50.6534L35.1463 45.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1785 39.6626L40.1033 42.5098L37.7119 44.845L39.8754 48.376L41.1851 44.5602L43.4064 40.6874L43.1785 39.6626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9717 45.585L39.193 49.0589L38.3383 53.7285L36.8008 50.6534L36.9717 45.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7183 37.84L26.0346 53.8424L29.5085 69.5598L28.8818 69.5029L24.8389 55.266L25.3516 36.9292L26.7183 37.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2307 44.3892L32.3562 55.9497L31.1605 70.0156H30.5337L26.8896 53.3296L27.2307 44.3892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0955 57.2026L31.8428 69.9019L33.7792 71.1546L35.3737 65.2892L33.6082 58.2274L33.0955 57.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4004 37.84L46.0833 53.8424L42.6094 69.5598L43.2361 69.5029L47.279 55.266L46.767 36.9292L45.4004 37.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8872 44.3892L39.7617 55.9497L40.9582 70.0156H41.5842L45.229 53.3296L44.8872 44.3892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0214 57.2026L40.2741 69.9019L38.3377 71.1546L36.7432 65.2892L38.5086 58.2274L39.0214 57.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5716 39.6626L33.1521 52.134L34.0637 58.1703L27.5146 43.4214L27.5716 39.6626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5458 39.6626L38.9653 52.134L38.0537 58.1703L44.6028 43.4214L44.5458 39.6626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5526 71.5532L42.7235 73.0908L41.5278 74.5714L41.129 76.9058L40.3321 77.2477L39.6484 73.7167L39.1934 72.4641L39.5914 71.6672L42.5526 71.5532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2569 71.667L38.1107 74.0584L39.9332 77.5893L39.4774 80.8354L38.1677 77.1905L37.0859 75.1402L37.2569 71.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4881 69.6738L42.3809 75.4822L43.6343 74.9702L44.6591 74.8563L44.4881 69.6738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5655 71.5532L29.3945 73.0908L30.5902 74.5714L30.9891 76.9058L31.7859 77.2477L32.4697 73.7167L32.9255 72.4641L32.5266 71.6672L29.5655 71.5532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8609 71.667L34.007 74.0584L32.1846 77.5893L32.6404 80.8354L33.95 77.1905L35.0318 75.1402L34.8609 71.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6289 69.6738L29.7363 75.4822L28.4836 74.9702L27.458 74.8563L27.6289 69.6738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7615 18.422L30.1348 19.4468L30.3627 21.6111L33.0959 19.9596L34.8044 19.7886L35.0323 16.9414L30.7615 18.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5335 22.8638L30.4766 25.5401L32.0141 24.8002L34.8613 24.5723L34.9753 20.9844L30.5335 22.8638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4763 26.7929L30.3623 29.47L32.1847 29.527L34.918 30.7796L35.0889 26.3379L30.4763 26.7929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8184 31.0645L32.4129 41.1437L34.9183 42.8522L35.2031 34.1396L34.5202 31.5765L30.8184 31.0645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3568 18.422L41.9835 19.4468L41.7556 21.6111L39.0223 19.9596L37.3138 19.7886L37.0859 16.9414L41.3568 18.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5843 22.8638L41.6413 25.5401L40.1037 24.8002L37.2565 24.5723L37.1426 20.9844L41.5843 22.8638Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.641 26.7929L41.755 29.47L39.9325 29.527L37.1992 30.7796L37.0283 26.3379L41.641 26.7929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2998 31.0645L39.7053 41.1437L37.1999 42.8522L36.915 34.1396L37.5987 31.5765L41.2998 31.0645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3378 28.8428L29.5088 35.2209L30.4196 37.5554L30.0785 38.467L26.0918 35.3349L26.5476 26.9634L29.3378 28.8428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.78 28.8428L42.6091 35.2209L41.6982 37.5554L42.0401 38.467L46.0261 35.3349L45.5702 26.9634L42.78 28.8428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4092 14.4351L27.0607 15.8587L25.9212 16.3715L25.0674 16.0866L25.4092 14.4351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7432 15.8589L26.9463 16.5426L29.2238 17.5104L29.6796 16.9984L27.7432 15.8589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 16.9414L29.3381 18.5929L28.8253 20.5285L26.8327 18.2511L26.5479 17.1693L26.7188 16.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1241 16.5996L25.921 17.2825L26.8895 19.2759L24.7822 18.593L25.1241 16.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4092 19.6175L28.4273 23.4895L28.7114 20.9272L26.32 19.5605L25.4092 19.6175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9532 19.7886L27.0605 23.2625L28.5403 24.971L28.3701 27.0776L27.6864 26.8496L25.5229 24.5152L24.7822 21.0413L24.9532 19.7886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7101 14.4351L45.0586 15.8587L46.1973 16.3715L47.0512 16.0866L46.7101 14.4351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3749 15.8589L45.1725 16.5426L42.8943 17.5104L42.4385 16.9984L44.3749 15.8589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4004 16.9414L42.7803 18.5929L43.2931 20.5285L45.2864 18.2511L45.5705 17.1693L45.4004 16.9414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9942 16.5996L46.1973 17.2825L45.2295 19.2759L47.336 18.593L46.9942 16.5996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7103 19.6175L43.6921 23.4895L43.4072 20.9272L45.7986 19.5605L46.7103 19.6175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1653 19.7886L45.0587 23.2625L43.5781 24.971L43.7491 27.0776L44.432 26.8496L46.5963 24.5152L47.3362 21.0413L47.1653 19.7886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7379 5.32437L26.3604 10.1611L35.1408 11.488L34.9186 6.64326L30.2689 5.16602L28.7379 5.32437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4574 5.32437L45.835 10.1611L37.0545 11.488L37.2768 6.64326L41.9264 5.16602L43.4574 5.32437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0483 10.7466L23.9277 12.3856L29.7931 15.9157L35.2596 15.0049L35.141 12.2295L26.0483 10.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.147 10.7466L48.2676 12.3856L42.4022 15.9157L36.9357 15.0049L37.0543 12.2295L46.147 10.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1774 29.3551L12.1973 39.8332L13.1089 42.0544L19.601 33.569L22.2203 26.792L18.1774 29.3551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1516 23.9448L17.4935 28.8994L10.3184 40.6309L9.80566 40.346L13.3366 33.7399L13.7916 30.323L15.5001 25.5394L17.1516 23.9448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9423 29.3551L59.9217 39.8332L59.01 42.0544L52.5187 33.569L49.8994 26.792L53.9423 29.3551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9669 23.9448L54.625 28.8994L61.8008 40.6309L62.3128 40.346L58.7819 33.7399L58.3269 30.323L56.6184 25.5394L54.9669 23.9448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5186 21.3257L19.0883 24.6288L21.6507 22.8633L23.701 18.7634L24.3839 14.3209L22.8464 13.1821L20.341 14.1499L18.5186 21.3257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1448 15.0615L17.9491 20.8129L18.746 25.4826L16.8665 22.6354L16.8096 18.3645L19.1448 15.0615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6007 21.3257L53.031 24.6288L50.4686 22.8633L48.4183 18.7634L47.7354 14.3209L49.2729 13.1821L51.7783 14.1499L53.6007 21.3257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9736 15.0615L54.1701 20.8129L53.3725 25.4826L55.2519 22.6354L55.3088 18.3645L52.9736 15.0615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3477 27.2482L22.3344 23.0913L21.8216 25.7676L18.6325 28.0458L18.3477 27.2482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7711 27.2482L49.7852 23.0913L50.2972 25.7676L53.4862 28.0458L53.7711 27.2482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8386 5.32327L21.3077 8.34142L19.3151 13.0111L19.2012 8.68327L21.8775 5.15234L24.8386 5.32327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2783 5.32327L50.8092 8.34142L52.8026 13.0111L52.9158 8.68327L50.2395 5.15234L47.2783 5.32327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5785 5.49399L22.1623 8.51213L20.3398 13.0678L25.0095 10.6764L27.6288 5.43701L25.5785 5.49399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5386 5.49399L49.9548 8.51213L51.7773 13.0678L47.1076 10.6764L44.4883 5.43701L46.5386 5.49399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46731 40.8872L10.2072 42.6527L12.3715 42.9945L12.5424 46.1836L11.4037 50.7393L10.663 50.6823L11.3818 47.6493L10.6131 47.6283L9.41034 50.8533L8.49951 50.7393L9.63122 47.4784L8.84058 47.3293L7.30302 50.7963L6.16429 50.6823L7.73073 47.0733L7.18907 46.7526L5.25346 49.8277L4.28488 49.7137L7.18907 44.1902L6.90497 43.7344L4.17093 44.8732L4 44.2472L6.22127 42.2538L9.46731 40.8872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5331 40.8872L61.7932 42.6527L59.6289 42.9945L59.458 46.1836L60.5975 50.7393L61.3374 50.6823L60.6186 47.6493L61.3874 47.6283L62.5901 50.8533L63.5017 50.7393L62.3692 47.4784L63.1598 47.3293L64.6974 50.7963L65.8361 50.6823L64.2697 47.0733L64.8113 46.7526L66.7469 49.8277L67.7155 49.7137L64.8113 44.1902L65.0962 43.7344L67.8295 44.8732L67.9996 44.2472L65.7791 42.2538L62.5331 40.8872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8434 1.1665L33.324 3.8428H26.8896L31.8434 1.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2755 1.1665L38.7949 3.8428H45.2301L40.2755 1.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.957 -3.16113L34.5202 0.539942L35.2031 5.83633L32.4698 1.22365L31.957 -3.16113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1611 -3.16113L37.5988 0.539942L36.915 5.83633L39.6483 1.22365L40.1611 -3.16113Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V72H0V0Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultWorkoutImage);
export default __webpack_public_path__ + "static/media/DefaultWorkoutImage.07791b3a0cb371fea0d377331f70b541.svg";
export { ForwardRef as ReactComponent };